<template>
  <dropdown-button
    :btn-class="`${btnClass}`"
    :svg-class="`tw-fill-current tw-text-pink-600 hover:tw-text-pink-500 tw-text-opacity-50`"
    :btn-icon-class="btnIconClass"
  >
    <template v-if="isSuperAdmin">
      <a
        target="_blank"
        class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
        :href="profileLink"
      > View Profile </a>
      <a
        v-if="data.profile.facebook"
        target="_blank"
        class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
        :href="facebookSearch"
      > Facebook Search </a>
      <a
        target="_blank"
        class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
        @click="adminAction('user:logout')"
      > Log Out </a>
      <a
        target="_blank"
        class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
        @click="adminAction('user:reload')"
      > Reload </a>
      <a
        target="_blank"
        class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
        @click="adminAction('user:ghostMessage')"
      > Ghost Message </a>
      <a
        target="_blank"
        class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
        @click="adminAction('user:debug')"
      > Debug </a>
      <a
        target="_blank"
        class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
        @click="impersonate()"
      > Become </a>
    </template>
    <a
      class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
      @click="adminAction('user:ban')"
    > Ban </a>
    <a
      class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
      @click="adminAction('user:disable')"
    > Disable </a>
    <a
      class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
      @click="adminAction('user:deleteData')"
    > Delete Data Only </a>
    <a
      class="tw-whitespace-no-wrap tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
      @click="adminAction('user:delete')"
    > Delete </a>
  </dropdown-button>
</template>

<script>
import permissions from '@/mixins/permissions';
import adminActions from '@/mixins/admin-actions';

export default {
  mixins: [
    permissions, //
    adminActions,
  ],

  props: {
    btnClass: {
      type: String,
      default: () => '',
    },
    btnIconClass: {
      type: String,
      default: () => 'tw-text-sm fas fa-ellipsis-h',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    modalId() {
      return `profile-action-${this.data.id}`;
    },
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },

    onClickOutside() {
      this.isOpen = false;
    },
  },
};
</script>
